import { ApiService } from '@frontend/sports/common/api-utils';
import { firstValueFrom } from 'rxjs';

export abstract class BaseCustomLogger<T> {
    protected readonly MAX_LOGGED_ITEMS = 50;
    protected readonly DELAY = 1000;

    private queue: T[] = [];
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    private timer: NodeJS.Timeout | null = null;

    constructor(
        private api: ApiService,
        private url: string,
    ) {}

    log(data: T): void {
        if (!this.isEnabled()) {
            return;
        }

        this.queue.push(data);
        this.sendLogs();
    }

    protected abstract isEnabled(): boolean;

    private sendLogs(): void {
        if (this.timer != null) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        this.timer = setTimeout(async () => {
            if (this.queue.length > 0) {
                await firstValueFrom(this.api.post(this.url, this.queue.slice(0, this.MAX_LOGGED_ITEMS)));
            }

            this.queue = [];
            this.timer = null;
        }, this.DELAY);
    }
}
